import { SaveBase } from "./SaveBase";
export class SaveMark {
    constructor() {
        this._saveuse = 0;
    }
    isSaveMark() {
        return true;
    }
    restore(runner) {
        runner._saveMark = this._preSaveMark;
        SaveMark.POOL[SaveMark.POOL._length++] = this;
    }
    static Create(runner) {
        var no = SaveMark.POOL;
        var o = no._length > 0 ? no[--no._length] : (new SaveMark());
        o._saveuse = 0;
        o._preSaveMark = runner._saveMark;
        runner._saveMark = o;
        return o;
    }
}
SaveMark.POOL = SaveBase._createArray();
